import {HTTP_INTERCEPTORS} from '@angular/common/http';

import {ErrorInterceptor} from './error-interceptor';
import {TokenInterceptor} from './token-interceptor';
import {LoadingInterceptor} from './loading-interceptor';
import {InstantChatErrorInterceptor} from '../pages/instant-login/interceptors/error-interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: InstantChatErrorInterceptor, multi: true }
];
